export default {
    setProjectList({ commit }, items) {
        commit("SET_PROJECT_LIST", items);
    },
    setSearchQuery({ commit }, query) {
        commit("SET_SEARCH_QUERY", query);
    },
    addFavoriteSite({ commit }, item) {
        commit("ADD_FAVORITE_SITE", item);
    },
    removeFavoriteSite({ commit }, item) {
        commit("REMOVE_FAVORITE_SITE", item);
    },
}